import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { ifDefined as l } from '../../../../node_modules/lit-html/directives/if-defined.js';
import { imgLazyLoadingResolver } from '../../../common/img-lazy-loading-resolver.js';
import { property as n } from '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/property.js';
import { state as t } from '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/state.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { metricsTrack } from '../../utilities/analytics/index.js';
import { isSameOrigin } from '../../utilities/backend-helpers/index.js';
import { scrollIntoView } from '../../utilities/behavior-helpers/index.js';
import '../../utilities/dom-helpers/index.js';
import { setLineClamp } from '../../utilities/text-helpers/index.js';
import css_248z from './content-card.scss.js';

class ContentCard extends s {
    constructor() {
        super(...arguments);
        this.abbreviated = false; // e.g. search result card
        this.isInSearch = false;
        this.responsive = true;
        this.headingSlot = null;
        this.textSlot = null;
        this.query = '(max-width: 1365px)';
        this.isMobile = false;
    }
    handleClick(e) {
        e.stopImmediatePropagation();
        const target = e.target;
        const url = this.renderRoot.querySelector('a.card')
            .href;
        const isOutbound = !isSameOrigin(url);
        metricsTrack('cevt_link_click', {
            dlv_event_category: 'link',
            dlv_event_action: `outbound ${isOutbound}`,
            dlv_link_outbound: isOutbound,
            dlv_link_hostname: new URL(url).hostname,
            dlv_link_element: target,
            dlv_link_classes: target.getAttribute('class'),
            dlv_link_text: target.textContent,
            dlv_link_url: url,
        });
        window.location.href = url;
    }
    setTabIndexAttributeForCarousels() {
        const parent = this.parentElement;
        if (!(parent === null || parent === void 0 ? void 0 : parent.classList.contains('swiper-slide')))
            return;
        const card = this.shadowRoot.querySelector('.card');
        if (parent === null || parent === void 0 ? void 0 : parent.classList.contains('swiper-slide-duplicate')) {
            card === null || card === void 0 ? void 0 : card.setAttribute('tabindex', '-1');
        }
        else {
            card === null || card === void 0 ? void 0 : card.setAttribute('tabindex', '0');
        }
    }
    handleTabKey(e) {
        if (e.key === 'Tab') {
            scrollIntoView(this, document.querySelector('.container > .top'), 50);
        }
    }
    firstUpdated() {
        var _a;
        (_a = document.querySelector('.fallback-link')) === null || _a === void 0 ? void 0 : _a.remove();
        setLineClamp(this, 80, 120);
        this.setTabIndexAttributeForCarousels();
        this.addEventListener('keyup', e => this.handleTabKey(e));
        imgLazyLoadingResolver(this);
    }
    _handleMediaQuery(event) {
        this.isMobile = event.detail.value;
    }
    render() {
        return x `<a href="${l(this.url)}" class="card ${this.isInSearch ? 'is-in-search' : ''}" @click="${this.handleClick}"><div class="card-body"><div class="card-image"><slot name="image"></slot></div><slot name="heading"></slot></div></a><lit-media-query .query="${this.query}" @changed="${this._handleMediaQuery}"></lit-media-query>`;
    }
}
ContentCard.styles = css_248z;
__decorate([
    n({ type: String })
], ContentCard.prototype, "url", void 0);
__decorate([
    n({ type: Boolean })
], ContentCard.prototype, "abbreviated", void 0);
__decorate([
    n({ type: Boolean })
], ContentCard.prototype, "isInSearch", void 0);
__decorate([
    n({ type: Boolean })
], ContentCard.prototype, "responsive", void 0);
__decorate([
    t()
], ContentCard.prototype, "headingSlot", void 0);
__decorate([
    t()
], ContentCard.prototype, "textSlot", void 0);
__decorate([
    t()
], ContentCard.prototype, "query", void 0);
__decorate([
    t()
], ContentCard.prototype, "isMobile", void 0);
customElements.define('content-card', ContentCard);

export { ContentCard };
